import React, {useEffect, useState} from "react";

import './ReportsTable.scss'
import {useRecoilValue} from "recoil";
import {grpcReportServiceSelector} from "../../state/grpc";
import {
  DataTable,
  DataTableSkeleton, Pagination, Table, TableBody, TableCell,
  TableContainer, TableHead, TableHeader, TableRow, TableSelectAll, TableSelectRow,
  TableToolbar, TableToolbarContent, TableToolbarSearch
} from "@carbon/react";
import PropTypes from "prop-types";

const ReportsTable = (props) => {
  const headers = [{
    key: 'systemCode', header: 'Codice sistema'
  }, {
    key: 'systemName', header: 'Nome sistema'
  }, {
    key: 'subject', header: 'Oggetto mail'
  }, {
    key: 'date', header: 'Data'
  }];

  const date = props.DateRef
  const reportsService = useRecoilValue(grpcReportServiceSelector)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [reports, setReports] = useState([])
  const [pageSize, setPageSize] = useState(25)
  const [firstRowIndex, setFirstRowIndex] = useState(0)

  useEffect(() => {
    const req = new proto.api.ListReportsRequest()
    req.setFromDate(date + " 00:00:00")
    req.setToDate(date + " 23:59:59")
    reportsService.listReports(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        setError(err)
      } else {
        setReports(resp.toObject().reportsList)
      }
      setLoading(false)
    })
  }, [date])

  if (loading) {
    return (
      <DataTableSkeleton
        columnCount={headers.length + 1}
        rowCount={5}
        headers={headers}
      />
    )
  }

  if (error) {
    return (<div>
      <span>ERROR!</span>
    </div>)
  }

  const handlePaginationChange = (page, newPageSize) => {
    if (newPageSize !== pageSize) {
      setPageSize(newPageSize);
    }
    setFirstRowIndex(newPageSize * (page - 1));
  }

  return (
    <DataTable
      rows={reports}
      headers={headers}
      isSortable
      overflowMenuOnHover={false}
      render={({
                 rows,
                 headers,
                 getHeaderProps,
                 getRowProps,
                 getSelectionProps,
                 getToolbarProps,
                 onInputChange,
                 getTableProps,
                 getTableContainerProps,
               }) => {
        return (
          <TableContainer title="Lista reports"
                          description="Lista dei reports ricevuti" {...getTableContainerProps()}>
            <TableToolbar {...getToolbarProps()} >
              <TableToolbarContent>
                <TableToolbarSearch onChange={onInputChange} size="lg"/>
              </TableToolbarContent>
            </TableToolbar>
            <Pagination
              totalItems={rows.length}
              backwardText="Precedente"
              forwardText="Successiva"
              pageSize={25}
              pageSizes={[10, 25, 50, 100]}
              itemsPerPageText="Elementi per pagina"
              pageRangeText={(_current, total) => `di ${total} ${total === 1 ? 'pagina' : 'pagine'}`}
              itemRangeText={(min, max, total) => `${min}–${max} of ${total} elementi`}
              onChange={({page, pageSize}) => handlePaginationChange(page, pageSize)}
            />
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  <TableSelectAll {...getSelectionProps()} />
                  {headers.map((header) => (<TableHeader {...getHeaderProps({header})}>
                    {header.header}
                  </TableHeader>))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.slice(firstRowIndex, firstRowIndex + pageSize).map((row) => (
                  <TableRow key={row.id} {...getRowProps({row})}>
                    <TableSelectRow {...getSelectionProps({row})} />
                    {row.cells.map((cell) => (<TableCell key={cell.id}>
                      {cell.value}
                    </TableCell>))}
                  </TableRow>))}
              </TableBody>
            </Table>
          </TableContainer>);
      }}
    />
  )
}

ReportsTable.propTypes = {
  DateRef: PropTypes.string.isRequired,
}

export default ReportsTable